import { authService } from '../../api/auth'

export const state = {
    currentUser: JSON.parse(localStorage.getItem('user')) || null,
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    status: {}
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        if (newValue) {
            localStorage.setItem('user', JSON.stringify(newValue))
        } else {
            localStorage.removeItem('user')
        }
    },
    
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo
        if (userInfo) {
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        } else {
            localStorage.removeItem('userInfo')
        }
    },
    
    LOGIN_REQUEST(state) {
        state.status = { loggingIn: true }
    },
    
    LOGIN_SUCCESS(state, user) {
        state.status = { loggedIn: true }
        state.currentUser = user
    },
    
    LOGIN_FAILURE(state) {
        state.status = {}
        state.currentUser = null
        state.userInfo = null
    },
    
    LOGOUT(state) {
        state.status = {}
        state.currentUser = null
        state.userInfo = null
    }
}

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!(state.currentUser && state.currentUser.access_token)
    },
    
    currentUser(state) {
        return state.currentUser
    },
    
    userInfo(state) {
        return state.userInfo
    },
    
    isLoggingIn(state) {
        return state.status && state.status.loggingIn
    }
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    async init({ dispatch }) {
        await dispatch('validate')
    },

    // Logs in the current user.
    async logIn({ commit, dispatch }, { email, password } = {}) {
        commit('LOGIN_REQUEST')
        
        try {
            const user = await authService.login(email, password)
            commit('LOGIN_SUCCESS', user)
            commit('SET_CURRENT_USER', user)
            
            // Fetch user info after successful login
            await dispatch('fetchUserInfo')
            
            return user
        } catch (error) {
            commit('LOGIN_FAILURE')
            throw error
        }
    },

    // Logs out the current user.
    async logOut({ commit }) {
        try {
            await authService.logout()
            commit('LOGOUT')
            commit('SET_CURRENT_USER', null)
            commit('SET_USER_INFO', null)
            return true
        } catch (error) {
            // Even if logout fails on server, clear local state
            commit('LOGOUT')
            commit('SET_CURRENT_USER', null)
            commit('SET_USER_INFO', null)
            return true
        }
    },

    // register the user
    // eslint-disable-next-line no-unused-vars
    async register({ commit }, { email, password } = {}) {
        // TODO: Implement register in authService
        throw new Error('Register functionality not yet implemented')
    },

    // reset password
    // eslint-disable-next-line no-unused-vars
    async resetPassword({ commit }, { email } = {}) {
        // TODO: Implement reset password in authService  
        throw new Error('Reset password functionality not yet implemented')
    },

    // Validates the current user's token and refreshes it
    async validate({ commit, state, dispatch }) {
        if (!state.currentUser || !state.currentUser.access_token) {
            commit('SET_CURRENT_USER', null)
            commit('SET_USER_INFO', null)
            return null
        }
        
        try {
            const tokenCheck = await authService.checkToken()
            if (tokenCheck.valid) {
                // If token is valid but we don't have user info, fetch it
                if (!state.userInfo) {
                    await dispatch('fetchUserInfo')
                }
                return state.currentUser
            } else {
                commit('SET_CURRENT_USER', null)
                commit('SET_USER_INFO', null)
                return null
            }
        } catch (error) {
            commit('SET_CURRENT_USER', null)
            commit('SET_USER_INFO', null)
            return null
        }
    },
    
    // Fetch user information
    async fetchUserInfo({ commit, state }) {
        if (!state.currentUser || !state.currentUser.access_token) {
            return null
        }
        
        try {
            const userInfo = await authService.getUserInfo()
            commit('SET_USER_INFO', userInfo)
            return userInfo
        } catch (error) {
            console.error('Failed to fetch user info:', error)
            return null
        }
    },
}
